import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import Hexagon from './Hexagon';
import { theme } from '../tailwind.config';

interface ThreeDotLoaderProps {
  animationDuration?: number;
  className?: string;
  numbetOfHexagon?: number;
}

const ThreeDotLoader = ({
  className,
  numbetOfHexagon = 3,
  animationDuration = 400,
}: ThreeDotLoaderProps) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCount((prev) => prev + 1);
    }, animationDuration);

    return () => clearInterval(timer);
  }, [setCount, animationDuration]);

  return (
    <div
      className={clsx('flex justify-between', className)}
      data-testid="three-dot-loader"
    >
      {Array.from(Array(numbetOfHexagon).keys()).map((i) => (
        <Hexagon
          key={i}
          size={10}
          hexagonColor={
            count % numbetOfHexagon === i
              ? theme.colors.blue
              : theme.colors.lightGray
          }
        />
      ))}
    </div>
  );
};

export default ThreeDotLoader;
